import { FC, memo, useRef } from 'react';

import { dom, json } from 'app/utils';
import { Button as Component, ButtonProps as Props, Menu as Subcomponent, MenuProps as Subprops, MenuItem } from '../external';
import { IButtonBase } from './button';
import { Icon } from './icon';

export interface IMenuButton extends IButtonBase {
  alignment?: 'left' | 'right';
  items?: MenuItem[],
}

const sizes: Record<string, Props['size']> = {
  'sm': 'small',
  'lg': 'large'
};

export const MenuButton: FC<IMenuButton> = memo(({ id, className, style, disabled, icon, label, link, outlined, rounded, severity, size, text, tooltip, badge, loading, alignment, items }) => {
  const sizing = sizes[size ?? 'md'];
  if (severity === 'primary') severity = undefined;
  if (typeof tooltip === 'string') tooltip = { label: tooltip, position: 'bottom' };

  const ref = useRef<Subcomponent>(null);

  const button: Props = { id, style, disabled, label, link, text, outlined, rounded, severity, badge, loading,
    className: dom.className('i-component', 'i-button', 'i-menu-button', className),
    icon: (icon ? <Icon name={icon} size={size} className={{ 'mr-3': label }} /> : undefined),
    size: sizing,
    type: 'button',

    tooltip: tooltip?.label,
    tooltipOptions: json.process(tooltip, { '$.label': false,
      '$.className': (cls, path): [string, any] => [path, dom.className('i-component', 'i-tooltip', cls)],
    }),

    onClick: (e) => ref.current?.toggle(e),
  };

  const menu: Subprops = {
    className: dom.className('i-component', 'i-menu'),
    popup: true,
    popupAlignment: alignment,
    model: items,
  };

  return (
    <>
      <Component { ...button } />
      <Subcomponent ref={ref} { ...menu } />
    </>
  );
});
